import { createRoot } from 'react-dom/client'
import { HataSiniri } from './Hata'
import { App } from './App'
import './styles.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root bulunamadi')
/*
 * Hata siniri EN DISTA: cizim sirasinda atilan bir istisna, bugune
 * kadar butun ekrani beyaza cevirip kullaniciya hicbir sey
 * soylemiyordu. Gerekcesi `Hata.tsx`in basinda.
 */
createRoot(root).render(
  <HataSiniri>
    <App />
  </HataSiniri>,
)
